/**
 * 控件选择值
 * */
export function control(type,key) {
  if (!type) return [];
  const date = [];
  const vacant = { name: '空值', val: 'vacant' };
  const noVacant = { name: '非空值', val: 'noVacant' };
/*
  let like = { name: '包含', val: 'like' };
  let nolike = { name: '不包含', val: 'nolike' };
*/
  const gt = { name: '大于', val: 'gt' };
  const gte = { name: '大于等于', val: 'gte' };
  const lt = { name: '小于', val: 'lt' };
  const lte = { name: '小于等于', val: 'lte' };
  const eq = { name: '等于', val: 'eq' };
  const neq = { name: '不等于', val: 'neq' };
  const between = { name: '介于', val: 'between' };
  const inArr = { name: '包含', val: 'in' };  //包含数组
  const noin = { name: '不包含', val: 'noin' };  //不包含数组
  if (type === 'file' || type === 'image') {
    date.push(vacant, noVacant);
  }
  if (type === 'status' || type === 'paystatus' || type === 'prestatus') {
    date.push(inArr, noin);
  }
  if (type === 'number') {
    date.push(gt, gte, lt, lte, eq, neq, vacant, noVacant, between);
  }
  if (type === 'relation-user') {
    const caUser = { name: '包含当前用户', val: 'curuser' };
    const qtUser = { name: '等于任一成员', val: 'qtUser' };
    const nQtUser = { name: '不等于任一成员', val: 'nQtUser' };
    if(key){
      date.push(caUser, qtUser, nQtUser, vacant, noVacant, inArr, noin);
    }else{
      date.push(qtUser, nQtUser, vacant, noVacant, inArr, noin);
    }

  }
  if (['text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(type) !== -1) {
    date.push(inArr, noin, vacant, noVacant);
  }
  if (type === 'date') {
    const thatDay = { name: '当天', val: 'thatDay' };
    const yesterday = { name: '昨天', val: 'yesterday' };
    const thisWeek = { name: '本周', val: 'thisWeek' };
    const lastWeek = { name: '上周', val: 'lastWeek' };
    const thisMonth = { name: '本月', val: 'thisMonth' };
    const lastMonth = { name: '上月', val: 'lastMonth' };
    const fixed = { name: '固定值', val: 'fixed' };
    date.push(thatDay, yesterday, thisWeek, lastWeek, thisMonth, lastMonth, fixed, between, vacant, noVacant, gte, lte);
  }
  if (type === 'organization' || type === 'roule') {
    date.push(inArr);
  }
  return date;
}


/**
 * 新增联动关联选项值
 */
export function relevancyControl(type){
  if (!type) return [];
  let date = [];

  let eq = { name: '等于', val: 'eq' };
  let inArr = { name: '包含', val: 'in' };
  let qtUser = { name: '等于任一成员', val: 'qtUser' };
  let gte = { name: '大于等于', val: 'gte' };
  let gt = { name: '大于', val: 'gt' };
  let lt = { name: '小于', val: 'lt' };
  let lte = { name: '小于等于', val: 'lte' };

  //- 单行输入框、多行输入框、单选、多选、副文本控件
  if (['text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check'].indexOf(type) !== -1) {
    date.push(eq, inArr);
  }

  //- 联系人
  if (type === 'relation-user') {
    date.push(qtUser);
  }

  //- 时间
  if (type === 'date') {
    date.push(eq);
  }

  //- 数值
  if (type === 'number') {
    date.push(eq,gte,gt,lte,lt);
  }

  //- 状态
  if (type === 'status') {
    date.push(inArr);
  }

  return date;

}

/**
 * 获取时间
 * */
export function getTime(type) {
  // 当天
  if (type.condition === 'thatDay') {
    return [0,0];
  }
  // 昨天
  if (type.condition === 'yesterday') {
    return [-1, 0];
  }
  // 本周
  if (type.condition === 'thisWeek') {
    return [0, 7];
  }
  // 上周
  if (type.condition === 'lastWeek') {
    return [-7, 0];
  }
  // 本月
  if (type.condition === 'thisMonth') {
    return [0, 30];
  }
  // 上月
  if (type.condition === 'lastMonth') {
    return [-30, 0];
  }
  return type.conditionValue;
}

/**
 * 数据筛选保存时关系转化
 * */
export function fileWhere(val) {
  console.log('关系转化', val)
  if (!val) return;
  // 空值
  if (val.condition === 'vacant') return { relation: 'isnull', value: '' };
  // 非空值
  if (val.condition === 'noVacant') return { relation: 'isnotnull', value: '' };
  // 等于任一成员
  if (val.condition === 'qtUser') return { relation: 'in', value: val.conditionValue };
  // 不等于任一成员
  if (val.condition === 'nQtUser') return { relation: 'noin', value: val.conditionValue };
  // 本周 or 上周 or 本月 or 上月 or 当天 or 昨天
  if (val.condition === 'thatDay') return { relation: 'between', value: [0,0] };
  if (val.condition === 'thisWeek' ||
      val.condition === 'lastWeek' ||
      val.condition === 'thisMonth' ||
      val.condition === 'yesterday' ||
      val.condition === 'lastMonth') return { relation: 'between', value: val.conditionValue };
  // 固定值
  if (val.condition === 'fixed') return { relation: 'eq', value: val.conditionValue };
  if (val.type === 'relation-user' &&
      val.condition === 'eq' ||
      val.type === 'relation-user' &&
      val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 && Array.isArray(val.conditionValue) ? (val.conditionValue).join(',') : val.conditionValue };
  return { relation: val.condition, value: val.conditionValue };
  // return { relation: val.condition, value: val.condition === 'eq' ? Number(val.conditionValue) : val.conditionValue };
}


/**
 * 仪表盘表单关联场景数据筛选保存时关系转化
 * */
export function InstrufileWhere(val) {
  console.log('关系转化', val)
  if (!val) return;
  // 空值
  if (val.condition === 'vacant') return { relation: 'isnull', value: '' };
  // 非空值
  if (val.condition === 'noVacant') return { relation: 'isnotnull', value: '' };
  // 等于任一成员
  if (val.condition === 'qtUser') return { relation: 'in', value: val.conditionValue };
  // 不等于任一成员
  if (val.condition === 'nQtUser') return { relation: 'noin', value: val.conditionValue };
  // 本周 or 上周 or 本月 or 上月 or 当天 or 昨天
  if (val.condition === 'thatDay') return { relation: 'between', value: [0,0] };
  if (val.condition === 'thisWeek' ||
      val.condition === 'lastWeek' ||
      val.condition === 'thisMonth' ||
      val.condition === 'yesterday' ||
      val.condition === 'lastMonth') return { relation: 'between', value: val.conditionValue };
  // 固定值
  if (val.condition === 'fixed') return { relation: 'eq', value: val.conditionValue };
  if(val.filedType != 'summary'){
    if (val.type === 'relation-user' &&
      val.condition === 'eq' ||
      val.type === 'relation-user' &&
      val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 ? (val.conditionValue).join(',') : val.conditionValue };

  }else{
    //- 汇总字段特殊处理（产品要求）
    if (val.SummaryType === 'relation-user' &&
      val.condition === 'eq' ||
      val.SummaryType === 'relation-user' &&
      val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 ? (val.conditionValue).join(',') : val.conditionValue };

  }



  return { relation: val.condition, value: val.conditionValue };
  // return { relation: val.condition, value: val.condition === 'eq' ? Number(val.conditionValue) : val.conditionValue };
}

/**
 * 横向连接，返回join 参数
 * */
export function retJoin(val) {
  let joins = [];
  for (let i = 0; i < val.length; i++) {
    let date = val[i].map(item => {
      if (item.id && item.name) return item.id + '.' + item.name;
      return null;
    });
    if (date.indexOf(null) === -1) joins.push(date);
  }
  return joins;
}

/**
 * 父路劲的两个组建不能是相同表单（横向连接）
 * */
export function xLinkNoLogin(list, path) {
  if (list.length <= 1) return false;
  // 根据id 查找到一串名称用来比对
  let name = list.map(val => {
    let str = path.find(item => {return item.id === val});
    return str.approvalId ? str.approvalId : str.name;
  });
  console.log('横向父级', name);
  for (let i = 0; i < name.length; i++) {
    let item = JSON.parse(JSON.stringify(name.splice(i, 1)));
    if (item.indexOf(name[i]) !== -1) return true;
  }
  return false;
}
/**
 * 类型比对
 * */
export function typeContrast(val) {
  let date = {
    'text': '文本类',
    'label': '文本类',
    'textarea': '文本类',
    'radio': '文本类',
    'checkbox': '文本类',
    'image': '文本类',
    'file': '文本类',
    'richTextWid': '文本类',
    'relation-check': '文本类',
    'status': '文本类',
    'number': '数值类',
    'date': '时间类',
    'relation-user': '用户ID',
    'organization': '组织'
  };
  if (date[val]) return date[val];
  return val;
}
